/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { subProductFromProjectTypeForAnalytics } from '@jira/platform__services-subproduct/src/index.tsx';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import type { SubProduct } from '@jira/platform__common-constants/src/sub-product-types.tsx';
import OnMountAndUpdate from '@atlassian/jira-common-util-op-triggers/src/on-mount-and-update/OpTrigger.tsx';
import TagMauEvent from './TagMauEvent.tsx';
import setCurrentSubProduct from './setCurrentSubProduct.tsx';
/* eslint-disable jira/filename-case */

type SubProductProps = {
	subProduct: SubProduct;
	allowMonolithDeferral?: boolean;
};
type ProjectKeyProps = {
	projectType: ProjectType;
	allowMonolithDeferral?: boolean;
};

type Props = SubProductProps | ProjectKeyProps;

const isSubProductProps = (props: Props): props is Pick<SubProductProps, 'subProduct'> =>
	'subProduct' in props && typeof props.subProduct === 'string';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { Props };

export const SubProductUpdater = ({
	allowMonolithDeferral = false,
	...props
}: Props): React.JSX.Element => {
	const subProduct = isSubProductProps(props)
		? props.subProduct
		: subProductFromProjectTypeForAnalytics(props.projectType);

	return (
		<>
			<OnMountAndUpdate op={setCurrentSubProduct} args={[subProduct, allowMonolithDeferral]} />
			<TagMauEvent subProduct={subProduct} />
		</>
	);
};
